/* eslint no-console:0 */
import ReactOnRails from "react-on-rails";
import App from "../app/app";

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({ App });
